import CourseLeadersSvc from '@/app/admin/modules/course_leaders/core/courseLeadersService';

export default {
  namespaced: true,

  state: () => ({
    items: null
  }),

  getters: {
    items: state => state.items,
  },

  mutations: {
    set(state, items) {
      state.items = items;
    },
  },

  actions: {
    async list({ state, commit }, params) {
      try {
        if (params && params.cache && state.items) return state.items;
        let res = await new CourseLeadersSvc().sessionsList();
        commit('set', res);
        return res;
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
};
